export const TOKEN_LINK_INVALID_COPY =
  "Este link é inválido ou expirou. Solicite um novo.";

export type TokenCheckResult = "valid" | "invalid" | "limited" | "error";

export function peekTokenFromLocation(): string {
  if (typeof window === "undefined") return "";
  return new URLSearchParams(window.location.search).get("token") ?? "";
}

/** Pulls `token` from the query string and drops it from the address bar. */
export function takeTokenFromLocation(path: string): string {
  const token = peekTokenFromLocation();
  window.history.replaceState(window.history.state, "", path);
  return token;
}

export async function checkTokenLink(checkPath: string, token: string): Promise<TokenCheckResult> {
  if (!token) return "invalid";
  try {
    const response = await fetch(checkPath, {
      method: "POST",
      credentials: "include",
      headers: { "content-type": "application/json", accept: "application/json" },
      body: JSON.stringify({ token }),
    });
    if (response.status === 429) return "limited";
    if (!response.ok) return "invalid";
    const body = (await response.json().catch(() => null)) as { valid?: unknown } | null;
    return body?.valid === true ? "valid" : "invalid";
  } catch {
    return "error";
  }
}
